import { Component, DoCheck, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ChamadoSuporte } from 'src/app/admihair/api/dto/chamado-suporte';
import { MensagemChamado } from 'src/app/admihair/api/dto/mensagem-chamado';
import { MensagemChamadoService } from 'src/app/admihair/service/mensagem-chamado.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ChamadoSuporteService } from 'src/app/admihair/service/chamado-suporte.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ChamadoSuporteAvaliacao } from 'src/app/admihair/api/dto/chamado-suporte-avaliacao';
import { UrlServidor } from 'src/app/admihair/util/url-servidor';

import { Client, IMessage } from '@stomp/stompjs';
import SockJS from 'sockjs-client';
import { ArquivoAnexo } from 'src/app/admihair/api/file/arquivo-anexo';
import { ConfirmationService } from 'primeng/api';
import { ChamadoSuporteRequest } from 'src/app/admihair/api/dto/chamado-suporte-request';

@Component({
  selector: 'app-chamado-empresa-chat',
  templateUrl: './chamado-empresa-chat.component.html',
  styleUrls: ['./chamado-empresa-chat.component.scss']
})
export class ChamadoEmpresaChatComponent extends AdmihairBaseComponent implements OnInit, OnDestroy, DoCheck {

  emojis = [
    '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😇', '😉', '😊', '🙂', '🙃', '😋', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '🤪', '😜', '😝', '😛',
    '🤑', '😎', '🤓', '🧐', '🤠', '🥳', '🤗', '🤡', '😏', '😶', '😐', '😑', '😒', '🙄', '🤨', '🤔', '🤫', '🤭', '🤥', '😳', '😞', '😟', '😠', '😡', '🤬', '😔',
    '😟', '😠', '😡', '🤬', '😔', '😕', '🙁', '😬', '🥺', '😣', '😖', '😫', '😩', '🥱', '😤', '😮', '😱', '😨', '😰', '😯', '😦', '😧', '😢', '😥', '😪', '🤤', '🎂'
  ];

  @ViewChild('chatWindow') private chatWindow!: ElementRef;

  textContent: string = '';
  listaMensagensChamado: MensagemChamado[] = [];
  ultimaQuantidadeMensagens: number = 0;
  chamadoSelecionado?: ChamadoSuporte;

  exibirBotaoEncerrar: boolean = false;

  mostrarDialogUpload: boolean = false;
  mostrarDialogDetalheChamado: boolean = false;
  
  progressoSalvarAnexo: boolean = false;
  listaMensagensArquivos: MensagemChamado[] = [];
  arquivosProcessando: number = 0;
  arquivosAnexados: ArquivoAnexo[] = [];
  maxFileSizeMB = 5;
  validTypes = [
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/gif',
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'text/csv'
  ];

  mostrarDialogAvaliar: boolean = false;
  chamadoSuporteAvaliacao: ChamadoSuporteAvaliacao = {};
  loadingAvaliacao: boolean = false;

  stompClient!: Client;

  constructor(private mensagemChamadoService: MensagemChamadoService,
    private chamadoService: ChamadoSuporteService,
    private confirmationService: ConfirmationService,
    private sanitizer: DomSanitizer,
    private localStorage: UtilStorageService,
    erroService: ErroService,
    storageService: UtilStorageService,
    router: Router,
    activatedRoute: ActivatedRoute
  ) { super(erroService, storageService, router, activatedRoute) }


  ngOnInit(): void {
    this.setExibirSpinnerPrincipal(true);
    this.carregarIdUrl();
    this.carregarChamadoSuporte();
    this.conectarWebSocket();
  }

  ngOnDestroy(): void {
    if (this.stompClient && this.stompClient.active) {
      this.stompClient.deactivate();
    }
  }

  ngDoCheck(): void {
    if (this.listaMensagensChamado.length !== this.ultimaQuantidadeMensagens) {
      this.ultimaQuantidadeMensagens = this.listaMensagensChamado.length;
      setTimeout(() => this.scrollToBottom(), 0);
    }
  }

  private scrollToBottom(): void {
    const chat = this.chatWindow.nativeElement;
    chat.scrollTop = chat.scrollHeight;
  }


  conectarWebSocket(): void {
    const token = this.localStorage.getToken();
    const socketUrl = `${UrlServidor.URL_BASE}ws-chat?token=${token}`;

    this.stompClient = new Client({
      webSocketFactory: () => new SockJS(socketUrl),
      reconnectDelay: 5000
    });

    this.stompClient.onConnect = () => {
      const chatId = 'chamado-' + this.idParametroUrl
      this.stompClient.subscribe(`/topico/chat/${chatId}`, (message: IMessage) => {
        const novaMensagem = JSON.parse(message.body);
        this.listaMensagensChamado.push(novaMensagem);

      });
    };

    this.stompClient.onStompError = (frame) => {
      console.error('Erro no STOMP:', frame.headers['message'], frame.body);
    };

    this.stompClient.activate();
  }


  sendMessage() {
    if (this.textContent == '' || this.textContent === ' ') {
      return;
    }
    else {
      const usuario = this.getUsuarioLogadoSistema();
      const mensagem: MensagemChamado = {
        chamadoSuporte: this.chamadoSelecionado,
        conteudo: this.textContent,
        usuario: usuario,
        tipoMensagem: 'TEXTO',
        categoria: 'CONVERSA',
      };

      this.enviarMensagem(mensagem);
      this.textContent = '';
    }
  }

  enviarMensagem(mensagem: MensagemChamado): void {
    this.stompClient.publish({
      destination: '/app/chat/enviar',
      body: JSON.stringify(mensagem)
    });

    this.textContent = '';
  }

  carregarChamadoSuporte() {
    this.chamadoService.buscarPorIdEEmpresa(this.idParametroUrl, this.getEmpresa().id).subscribe({
      next: (data: ChamadoSuporte) => {
        this.chamadoSelecionado = data;
        this.verifificarExibirBotaoEncerrar();
        this.carregarMensagens();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })
  }

  verifificarExibirBotaoEncerrar() {
    if (this.chamadoSelecionado?.solicitado === 'EMPRESA' &&
       (this.chamadoSelecionado.status === 'ABERTO' ||
        this.chamadoSelecionado.status === 'RECEBIDO' ||
        this.chamadoSelecionado.status === 'EM_ATENDIMENTO'
       )) {
      this.exibirBotaoEncerrar = true;
    } else {
      this.exibirBotaoEncerrar = false;
    }
  }

  verificarStatusChamado() {
    if (this.chamadoSelecionado?.status === 'ENCERRADO' &&
       this.chamadoSelecionado.solicitado === 'FRANQUIA') {
        this.abrirDialogAvaliacao();
    }
  }

  abrirDialogAvaliacao() {
    this.chamadoSuporteAvaliacao = {};
    this.mostrarDialogAvaliar = true;
  }

  carregarMensagens() {
    this.mensagemChamadoService.listarPoChamadoId(this.chamadoSelecionado?.id).subscribe({
      next: (data: MensagemChamado[]) => {
        this.listaMensagensChamado = data;
        this.setExibirSpinnerPrincipal(false);
        this.verificarStatusChamado();
      },
      error: (err: any) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(err);
      }
    })

  }

  encerrarChamado() {
    this.confirmationService.confirm({
      message: 'Tem certeza que seja encerrar o chamado?',
      header: 'Confirmação',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      icon: 'pi pi-info-circle',
      accept: () => {
        const chamadoEncerramento: ChamadoSuporteRequest = {
          id: this.chamadoSelecionado?.id,
          empresa: this.chamadoSelecionado?.empresa,
          status: 'ENCERRADO',
          adicionaBaseConhecimento: false,
          usuarioFechamento: this.getUsuarioLogadoSistema()
        }

        this.chamadoService.encerrar(chamadoEncerramento).subscribe({
          next: () => {
            this.carregarChamadoSuporte();
          },
          error: (err: any) => {
            this.exibirMensagemErro(err);
          }
        })
      }
    });
    
  }

  

  avaliarChamado() {
    this.loadingAvaliacao = true;
    this.chamadoSuporteAvaliacao.idChamado = this.chamadoSelecionado?.id;
    this.chamadoSuporteAvaliacao.usuarioAvaliacao = this.getUsuarioLogadoSistema();
    this.chamadoSuporteAvaliacao.empresaId = this.getEmpresa().id
    this.chamadoSuporteAvaliacao.status = 'ENCERRADO_AVALIADO';
    this.chamadoService.avaliar(this.chamadoSuporteAvaliacao).subscribe({
      next: () => {
        this.loadingAvaliacao = false;
        this.mostrarDialogAvaliar = false;
        this.carregarChamadoSuporte();
      },
      error: (err: any) => {
        this.loadingAvaliacao = false;
        this.mostrarDialogAvaliar = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  ignorarAvaliacaoChamado() {
    this.loadingAvaliacao = true;
    this.chamadoSuporteAvaliacao.idChamado = this.chamadoSelecionado?.id;
    this.chamadoSuporteAvaliacao.usuarioAvaliacao = this.getUsuarioLogadoSistema();
    this.chamadoSuporteAvaliacao.empresaId = this.getEmpresa().id;
    this.chamadoSuporteAvaliacao.status = 'ENCERRADO_NAO_AVALIADO';
    this.chamadoService.avaliar(this.chamadoSuporteAvaliacao).subscribe({
      next: () => {
        this.loadingAvaliacao = false;
        this.mostrarDialogAvaliar = false;
        this.carregarChamadoSuporte();
      },
      error: (err: any) => {
        this.loadingAvaliacao = false;
        this.mostrarDialogAvaliar = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  abrirImagem(imagemBase64?: string) {
    if (imagemBase64) {
      const novaJanela = window.open();
      if (novaJanela) {
        novaJanela.document.write(`
          <html>
            <head><title>Visualizar Imagem</title></head>
            <body style="margin:0">
              <img src="${imagemBase64}" style="width:auto; height:auto; display:block;"/>
            </body>
          </html>
        `);
      }
    }
  }

  abrirDialogUpload() {
    this.mostrarDialogUpload = true;
  }
  
  abrirDialogDetalheChamado() {
    this.mostrarDialogDetalheChamado = true;
  }

  salvarAnexos() {
    this.progressoSalvarAnexo = true;

    this.mensagemChamadoService.salvarListaMensagensAnexadas(this.listaMensagensArquivos).subscribe({
      next: () => {
        this.progressoSalvarAnexo = false;
        this.mostrarDialogUpload = false;
        this.arquivosAnexados = [];
        this.listaMensagensArquivos = [];
      },
      error: (err: any) => {
        this.progressoSalvarAnexo = false;
        this.exibirMensagemErro(err);
      }
    })

  }

  addFile(file: File) {
    this.arquivosProcessando++;

    const tipoArquivo = this.obterTipoArquivo(file);
    const nomeArquivo = file.name;

    this.fileToBase64(file).then(base64 => {
      const mensagem: MensagemChamado = {
        chamadoSuporte: this.chamadoSelecionado,
        conteudo: base64,
        usuario: this.getUsuarioLogadoSistema(),
        tipoMensagem: tipoArquivo,
        categoria: 'CONVERSA',
        nomeArquivo: file.name
      };

      this.listaMensagensArquivos.push(mensagem);
      const isImagem = tipoArquivo === 'IMAGEM';

      this.arquivosAnexados.push(
        {
          preview: isImagem ? this.sanitizer
            .bypassSecurityTrustUrl(URL.createObjectURL(file)) : undefined,
          mensagem: mensagem,
          nome: nomeArquivo,
          icone: !isImagem ? this.obterIconeArquivo(tipoArquivo) : undefined
        }
      )

    }).catch(error => {
      console.error('Erro ao processar arquivo:', error);
    }).finally(() => {
      this.arquivosProcessando--;
    });
  }

  onPaste(event: ClipboardEvent) {
    const items = event.clipboardData?.items;
    if (!items) return;
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (item.type.startsWith('image/')) {
        const file = item.getAsFile();
        if (file) {
          const validacao = this.validarArquivo(file);
          if (validacao.valido) {
            this.addFile(file);
          } else {
            this.exibirMensagemErroArquivo(validacao.mensagemErro);
          }
        }

      }
    }
  }

  onFileSelect(event: Event) {
    const target = event.target as HTMLInputElement;
    if (target.files) {
      Array.from(target.files).forEach(file => {
        const validacao = this.validarArquivo(file);
        if (validacao.valido) {
          this.addFile(file);
        } else {
          this.exibirMensagemErroArquivo(validacao.mensagemErro);
        }
      });
      target.value = '';
    }
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    if (event.dataTransfer?.files) {
      Array.from(event.dataTransfer.files).forEach(file => {
        const validacao = this.validarArquivo(file);
        if (validacao.valido) {
          this.addFile(file);
        } else {
          this.exibirMensagemErroArquivo(validacao.mensagemErro);
        }
      });
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  removerArquivo(index: number) {
    const arquivo = this.arquivosAnexados[index];
    const i = this.listaMensagensChamado.indexOf(arquivo.mensagem);
    if (i >= 0) {
      this.listaMensagensChamado.splice(i, 1);
    }
    this.arquivosAnexados.splice(index, 1);
  }

  private fileToBase64(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });
  }

  isValidFile(file: File): boolean {
    const isTypeValid = this.validTypes.includes(file.type);
    const isSizeValid = file.size <= this.maxFileSizeMB * 1024 * 1024;
    return isTypeValid && isSizeValid;
  }

  validarArquivo(file: File): { valido: boolean, mensagemErro?: string } {
    const tamanhoMaximoBytes = this.maxFileSizeMB * 1024 * 1024;

    const extensao = file.name.split('.').pop()?.toUpperCase() || 'DESCONHECIDO';

    if (!this.validTypes.includes(file.type)) {
      return {
        valido: false,
        mensagemErro: `Tipo de arquivo "${extensao}" não é permitido. Aceitamos imagens, PDF, DOCX e CSV.`
      };
    }

    if (file.size > tamanhoMaximoBytes) {
      return {
        valido: false,
        mensagemErro: `O arquivo "${file.name}" excede o tamanho máximo permitido de ${this.maxFileSizeMB}MB.`
      };
    }
    return { valido: true };
  }

  exibirMensagemErroArquivo(error?: string) {
    this.messagesDialog = [{
      severity: 'warn', summary: 'Anexo inválido:',
      detail: error ? error : 'Erro ao anexar'
    }];
    this.messagemVisivelDialog = true;
  }

  private obterTipoArquivo(file: File): string {
    const tipoMime = file.type;
    const extensao = file.name.split('.').pop()?.toLowerCase() || '';

    if (tipoMime.startsWith('image/')) {
      return 'IMAGEM';
    }

    switch (extensao) {
      case 'pdf':
        return 'PDF';
      case 'csv':
        return 'CSV';
      case 'docx':
        return 'DOCX';
      default:
        return 'DOCUMENTO';
    }
  }

  obterIconeArquivo(tipo?: string) {
    switch (tipo) {
      case 'IMAGEM':
        return 'pi pi-image';
      case 'PDF':
        return 'pi pi-file-pdf';
      case 'CSV':
        return 'pi pi-file-excel';
      case 'DOCX':
        return 'pi pi-file';
      default:
        return 'pi pi-file';
    }
  }

  onEmojiSelect(emoji: string) {
    this.textContent += emoji;
  }


  obterMimeTypeBase64(base64: string): string {
    const result = /^data:(.*?);base64,/.exec(base64);
    return result ? result[1] : 'application/octet-stream';
  }

  baixarArquivoUrl(url?: string) {
    if(url) {
      window.open(url, '_blank');
    }
  }


}
